const lang = [
    {code: 'en', label: 'english'},
    {code: 'th', label: 'ไทย'},
    {code: 'lo', label: 'ลาว'}
]

export default lang